module.exports = require("regenerator-runtime");


//////////////////
// WEBPACK FOOTER
// external "regenerator-runtime"
// module id = 123
// module chunks = 0